export function exibirMensagem(tipo, texto) {
    return { type: 'SHOW_MESSAGE', mensagem: {tipo, texto} };
}

export function apagarMensagem() {
    return { type: 'DELETE_MESSAGE' };
}


// WEBPACK FOOTER //
// ./src/redux/actions/mensagemAction.js